module.exports = __webpack_public_path__ + "static/media/B_F02.2ae55854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_F02.png
// module id = 64
// module chunks = 0